import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, YoutubeIcon, LinkedinIcon, MailIcon, PhoneIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Logo } from './Logo';
import { useTheme } from '../context/ThemeContext';
export function Footer() {
  const {
    isArabic
  } = useLanguage();
  const {
    theme
  } = useTheme();
  return <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800" data-id="element-449">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-450">
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-451">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-452">
            <Link to="/" className="flex items-center mb-4" data-id="element-453">
              <Logo width={32} height={32} color={theme === 'dark' ? '#60A5FA' : '#3B82F6'} data-id="element-454" />
              <span className="ml-2 text-xl font-bold text-gray-900 dark:text-white" data-id="element-455">
                Arabicwithenglish
              </span>
            </Link>
            <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-456">
              {isArabic ? 'تعلم اللغة الإنجليزية بطريقة مبتكرة مصممة خصيصًا للمتحدثين باللغة العربية' : 'Learn English in an innovative way designed specifically for Arabic speakers'}
            </p>
            <div className="flex space-x-4" data-id="element-457">
              <a href="https://www.facebook.com/profile.php?id=61552531610209&ref=ig_profile_ac" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors" data-id="element-458">
                <FacebookIcon className="w-5 h-5" data-id="element-459" />
              </a>
              <a href="https://www.instagram.com/arabicwithenglish/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-pink-600 dark:text-gray-400 dark:hover:text-pink-400 transition-colors" data-id="element-460">
                <InstagramIcon className="w-5 h-5" data-id="element-461" />
              </a>
              <a href="#" className="text-gray-500 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400 transition-colors" data-id="element-462">
                <YoutubeIcon className="w-5 h-5" data-id="element-463" />
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-700 dark:text-gray-400 dark:hover:text-blue-500 transition-colors" data-id="element-464">
                <LinkedinIcon className="w-5 h-5" data-id="element-465" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-466">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4" data-id="element-467">
              {isArabic ? 'روابط سريعة' : 'Quick Links'}
            </h3>
            <ul className="space-y-2" data-id="element-468">
              {[{
              label: {
                en: 'Home',
                ar: 'الرئيسية'
              },
              href: '/'
            }, {
              label: {
                en: 'Learning Path',
                ar: 'مسار التعلم'
              },
              href: '/learn/path'
            }, {
              label: {
                en: 'Video Lessons',
                ar: 'دروس الفيديو'
              },
              href: '/learn/video-lessons'
            }, {
              label: {
                en: 'Practice Exercises',
                ar: 'تمارين تطبيقية'
              },
              href: '/learn/practice'
            }, {
              label: {
                en: 'About Us',
                ar: 'عن الشركة'
              },
              href: '/about'
            }].map((link, i) => <li key={i} data-id="element-469">
                  <Link to={link.href} className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors" data-id="element-470">
                    {isArabic ? link.label.ar : link.label.en}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Resources */}
          <div data-id="element-471">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4" data-id="element-472">
              {isArabic ? 'المصادر' : 'Resources'}
            </h3>
            <ul className="space-y-2" data-id="element-473">
              {[{
              label: {
                en: "Beginner's Guide",
                ar: 'دليل المبتدئين'
              },
              href: '/resources/beginners-guide'
            }, {
              label: {
                en: 'Grammar Guide',
                ar: 'دليل القواعد'
              },
              href: '/resources/grammar'
            }, {
              label: {
                en: 'Pronunciation',
                ar: 'النطق'
              },
              href: '/resources/pronunciation'
            }, {
              label: {
                en: 'Business English',
                ar: 'الإنجليزية للأعمال'
              },
              href: '/resources/business-english'
            }, {
              label: {
                en: 'Blog',
                ar: 'المدونة'
              },
              href: '/blog'
            }].map((link, i) => <li key={i} data-id="element-474">
                  <Link to={link.href} className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors" data-id="element-475">
                    {isArabic ? link.label.ar : link.label.en}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-476">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4" data-id="element-477">
              {isArabic ? 'تواصل معنا' : 'Contact Us'}
            </h3>
            <ul className="space-y-3" data-id="element-478">
              <li className="flex items-start gap-3" data-id="element-479">
                <MailIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5" data-id="element-480" />
                <div data-id="element-481">
                  <a href="mailto:contact@arabicwithenglish.com" className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors" data-id="element-482">
                    contact@arabicwithenglish.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-483">
                <PhoneIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5" data-id="element-484" />
                <div data-id="element-485">
                  <a href="tel:+201234567890" className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors" data-id="element-486">
                    +20 123 456 7890
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-487">
                <GlobeIcon className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5" data-id="element-488" />
                <div className="text-gray-600 dark:text-gray-400" data-id="element-489">
                  {isArabic ? 'القاهرة، مصر' : 'Cairo, Egypt'}
                </div>
              </li>
            </ul>
          </div>
        </div>
        {/* Copyright */}
        <div className="py-6 border-t border-gray-200 dark:border-gray-800 text-center" data-id="element-490">
          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-491">
            &copy; {new Date().getFullYear()} Arabicwithenglish.{' '}
            {isArabic ? 'جميع الحقوق محفوظة.' : 'All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>;
}